import React from "react";
import Card from "../../../../core/Card";
import Typography from "../../../../core/Typography";
import Button from "../../../../core/Button";
import Checkbox from "../../../../core/CheckBox";
import Input from "../../../../core/Inputs/DefaultInput";
import { useDevice } from "../../../customHooks";
import { useEffect, useRef, useState } from "react";
import style from "../../../style.module.css";
// routes
import { Link } from "react-router-dom";
import Title from "../Title";
import Axios from "axios";

// import Header from "../../survey/survey-form/landing-page/widgets/Header";
import Svg from "../../../../component/common/Svg";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { useDispatch } from "react-redux";
import { resendFpOtp } from "../../../../store/actions/authAction";



export const ForgetPasswordConfirmation = () => {
  let device = useDevice();
  const [isOpen, setOpen] = useState(false);
  const inputRef = useRef();
  const [count, setCount] = useState(0);
  const [isChecked, setChecked] = useState(false);

  const [timer, setTimer] = useState(60); 
  const [timerStarted, setTimerStarted] = useState(false);

  const dispatch = useDispatch();


  useEffect(() => {
    if (!timerStarted) {
      const interval = setInterval(() => {
        setTimer(prevTimer => (prevTimer === 0 ? 60 : prevTimer - 1)); // Decrement timer every second
      }, 1000);
      // setTimerStarted(true);
      // Clear interval on component unmount or route change
      return () => clearInterval(interval);
    }
  }, [timerStarted]);

  useEffect(() => {
    if (timer === 0){
    setTimerStarted(true);
    }
  },[timer] )


  const formatTimer = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;
    return `${formattedMinutes}:${formattedSeconds}`;
  };


  useEffect(() => {
    const str = String(inputRef?.current?.props.value)?.length;
    setCount(str);
  }, []);
  const handleCount = e => {
    setCount(String(e.target.value).length);
  };
  const [otp, setOtp] = useState('');

  const urlParams = new URLSearchParams(window.location.search);
  let email = urlParams.get('email');

  React.useEffect(() => {
    if (email == null) {
      window.location = '/ForgotPassword';
    }
  });

  const verifyOtp = (props) => {
    // alert(props.match.params.email);

    Axios.post(process.env.REACT_APP_NODE_API_URL + "/users/verify-fp-otp", {
      email: email,
      otp: otp,
    }).then((response) => {
      console.log(response.data)
      if (response.data.statusCode == 200) {
        toast.success('Verification Successfull!', {
          position: toast.POSITION.TOP_RIGHT
        });
        // alert("Verification Successfull!");
        window.location = '/admin/reset-password/?email=' + email;
      } else {
        toast.error(response.data.msg);
      }
    });

  }

  const otpResend = () => {
    let payload = {
      email: email,
    }
    dispatch(resendFpOtp(payload))
    setTimerStarted(false)
  }

  return (
    <>
      <div className='d-flex flex-column site-main-wrapper login-page'>

        <div className="flex-grow-1 main-content-wrap d-flex align-items-center justify-content-center">
          <div className="container">
            <div className="form-outer-wrapper">
              <div className="logo-wrap text-center">
                <Link to="/#0t" className='home-logo'>
                  <Svg name="logo" />
                </Link>
              </div>
              <div className="form-wrapper">
                <div className="form-heading text-center">
                  <h3>Let us know it’s you</h3>
                  <p>Last step! To secure your account, enter the code  we just send to <span className="black">{email}</span></p>
                </div>
                <div className="field-wrapper">
                  <div className="mb__20 position-relative"> {/* Add Class error to this div once error occurs and if its valid, add class success*/}
                    < Input
                      ref={inputRef}
                      type='text'
                      view='outlined'
                      dense={false}
                      color='default'
                      label=''
                      placeholder='Enter OTP'
                      clearButton={true}
                      success={false}
                      error={false}
                      fill={true}
                      errorHelperText={null}
                      maxLength={6} 
                      className={"formsinput"}
                      value={otp}
                      name="otp"
                      // onInput={e => setOtp(e.target.value)}
                      onInput={(e) => {
                        setOtp(e.target.value.replace(/\D/g, ''));
                      }}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      onChange={(e) => {
                        setOtp(e.target.value.replace(/\D/g, ''));
                      }}
                    />
                  </div>
                  <div className={"additional-info justify-content-between" + " " + style.additional_line} style={{ marginBottom: "20px" }}>
                  <div className="text-primary">
                    <Typography
                      type="caption"
                      fill={true}
                      color="primary"
                      colorStep={60}
                      tagName="div"
                    >
                    <b className={timerStarted ? "d-none" : "d-block"}>  {formatTimer(timer)}</b>
                    </Typography>
                 
                  </div>
                    <a  disabled={!timerStarted} style={{ color: "var(--blue60)" }}  onClick={timerStarted?otpResend: ''}>
                      <Typography
                        type="caption"
                        fill={true}
                        color="primary"
                        colorStep={60}
                        tagName="div"
                       
                      >
                        <b className={timerStarted ? "text-primary" : "text-secondary"}> Resend code</b>
                      </Typography>
                    </a>
                  </div>
                </div>
                <div className="button-wrap">
                  <Button className={"formsbutton"}
                    type="default"
                    view="filled"
                    color="primary"
                    text="Submit"
                    fill={true}

                    // onClick={() => setOpen(true)}
                    onClick={verifyOtp}
                  />
                </div>
                <div className="form-text text-center">
                  <p>Wrong email address? <Link to="/ForgotPassword"> Change it</Link></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgetPasswordConfirmation;
